import { render } from "./SmileLogoIcon.vue?vue&type=template&id=55ed473e"
import script from "./SmileLogoIcon.vue?vue&type=script&lang=js"
export * from "./SmileLogoIcon.vue?vue&type=script&lang=js"

import "./SmileLogoIcon.vue?vue&type=style&index=0&id=55ed473e&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__